import React from 'react'

// The saved-card summary panel shown on the update-card screen and the
// payment-method-updated success screen. Reused verbatim on both so the card
// presentation stays identical. Renders nothing without a card.
//
// Props: { card: { brand, last4, expMonth, expYear } | null }

const formatExpiry = ({ expMonth, expYear }) => {
  if (!expMonth || !expYear) return null
  const mm = String(expMonth).padStart(2, '0')
  const yy = String(expYear).slice(-2)
  return `${mm} / ${yy}`
}

const CurrentCardPanel = ({ card }) => {
  if (!card || !card.last4) return null

  const brand = (card.brand || 'Card').replace(/\b\w/g, (c) => c.toUpperCase())
  const expiry = formatExpiry(card)

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 12,
        border: '1px solid var(--base-color-scale-gray-1)',
        background: 'var(--base-color-scale-gray-0)',
        borderRadius: 8,
        padding: '14px 16px',
        marginBottom: 22,
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <span
          style={{
            fontSize: 11,
            fontWeight: 700,
            letterSpacing: '0.04em',
            textTransform: 'uppercase',
            color: 'var(--base-color-scale-gray-9)',
            border: '1px solid var(--base-color-scale-gray-2)',
            borderRadius: 4,
            padding: '4px 7px',
            background: '#fff',
          }}
        >
          {brand}
        </span>
        <div>
          <div style={{ fontSize: 14, fontWeight: 600, color: 'var(--base-color-scale-gray-9)' }}>
            {brand} ending in {card.last4}
          </div>
          {expiry && (
            <div style={{ fontSize: 12, color: 'var(--base-color-scale-gray-6)', marginTop: 2 }}>
              Expires {expiry}
            </div>
          )}
        </div>
      </div>
      <span style={{ fontSize: 12, color: 'var(--base-color-scale-gray-6)' }}>Current card</span>
    </div>
  )
}

export default CurrentCardPanel
